import apiClient from "./axios";
import { ApiResponse, LoginResponse } from "../types";

export const authApi = {
  login: async (email: string, password: string) => {
    const { data } = await apiClient.post<ApiResponse<LoginResponse>>(
      "/admin/auth/login",
      { email, password },
    );
    return data.data;
  },

  logout: async (refreshToken: string) => {
    const { data } = await apiClient.post<ApiResponse<{ message: string }>>(
      "/admin/auth/logout",
      { refreshToken },
    );
    return data.data;
  },

  me: async () => {
    const { data } = await apiClient.get<ApiResponse<LoginResponse["admin"]>>(
      "/admin/auth/me",
    );
    return data.data;
  },

  updateProfile: async (payload: { firstName: string; lastName: string }) => {
    const { data } = await apiClient.patch<ApiResponse<LoginResponse["admin"]>>(
      "/admin/auth/me",
      payload,
    );
    return data.data;
  },

  updateProfilePhoto: async (profilePhotoBase64: string) => {
    const { data } = await apiClient.patch<ApiResponse<LoginResponse["admin"]>>(
      "/admin/auth/me/profile-photo",
      { profilePhotoBase64 },
    );
    return data.data;
  },

  changePassword: async (currentPassword: string, newPassword: string) => {
    const { data } = await apiClient.post<ApiResponse<{ message: string }>>(
      "/admin/auth/change-password",
      { currentPassword, newPassword },
    );
    return data.data;
  },
};
